import { JsonObject } from '../../helpers';
import AwsIcon from '@/assets/connector-icons/aws.svg';
import { ConnectorModel } from './connector.model';
import Environment from '@/lib/environment';
import { makeQueryString } from '@/lib/url-helpers';
import { v4 as uuidv4 } from 'uuid';

// default to us-east-1 for now since it's the only region bedrock regularly works in
const DEFAULT_AWS_REGION = 'us-east-1';

export type AwsAuthType = 'role-assumption' | 'access-keys';

export type AwsConfig = {
  authType?: AwsAuthType;
  awsRegion?: string;
  // Role assumption fields
  awsAccountId?: string;
  crossAccountRoleARN?: string;
  externalId?: string;
  // Access key fields
  accessKeyId?: string;
  secretAccessKey?: string;
  accessKeyIdLast4?: string;
};

export class AwsConnectorModel extends ConnectorModel {
  config: AwsConfig;

  // @todo schema extends base and covers config

  constructor(props: JsonObject = {}) {
    super(props);

    const data = props as Record<keyof ConnectorModel, unknown>;

    this.type = 'aws';
    this.typeLabel = 'AWS';
    this.iconSVG = AwsIcon;

    this.supportedFeatures = {
      siem: true,
      privateModels: true,
      contextData: true,
      ingress: false,
    };

    this.config = (data.config as AwsConfig) || {
      authType: 'role-assumption',
      awsRegion: DEFAULT_AWS_REGION,
      awsAccountId: '',
      crossAccountRoleARN: '',
      externalId: '',
      accessKeyId: '',
      secretAccessKey: '',
    };

    this.configSecrets = ['secretAccessKey'];
    this.contextProviderTypes = ['customer-bedrock-knowledge-base'];
    this.telemetryDestinationTypes = ['s3'];
    this.canListProviderModels = true;
  }

  static getDefaultRoleARN(accountId: string): string {
    return `arn:aws:iam::${accountId}:role/surepath-cloud-connector-role`;
  }

  get stackLink(): string {
    const host = `https://${this.config.awsRegion}.console.aws.amazon.com/cloudformation/home?region=${this.config.awsRegion}#/stacks/quickcreate`;

    const params = {
      templateURL: Environment.AWS_CF_TEMPLATE_URL,
      param_BucketSuffix: uuidv4(),
      param_ExternalId: this.config.externalId || '',
      stackName: 'surepath-connector',
    };

    return `${host}/?${makeQueryString(params)}`;
  }
}
